export default __webpack_public_path__ + "static/media/img_vision_04_w.6e087a5e.png";